import type { Offer } from "@types_def/models/offer.types";
import type { FunctionComponent } from "react";

export const DriverNameCell: FunctionComponent = ({ children }) =>
  children && (children as Offer).driver?.fullName ? (children as Offer).driver?.fullName : <></>;
